import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { API_CALL_ERROR } from './../../../store/action';
import { ApiService } from './../../../api/api.service';
import { AppInjector } from './../../../app-injector';
import { takeEvery, put } from 'redux-saga/effects';
import {
  FETCH_PAYMENT_DETAIL_REQUESTED,
  FETCH_PAYMENT_DETAIL_SUCCEEDED,
  EDIT_PAYMENT_ITEM_SUCCEEDED,
  EDIT_PAYMENT_ITEM_REQUESTED,
  GET_PAYMENT_METHODS_REQUESTED,
  GET_PAYMENT_METHODS_SUCCEEDED,
  SEND_PAYMENT_TO_ACCOUNTING_REQUESTED,
  CANCEL_PAYMENT_REQUESTED,
  CANCEL_PAYMENT_SUCCEEDED
} from "./edit.actions";
import {FETCH_CUSTOMER_DETAIL_REQUESTED} from "../../customer/edit/edit.actions";
import {NotificationService} from "../../../common/services/notification/notification.service";


function* doPaymentRequest(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.payment.update(action.data).toPromise();
    yield put({ type: EDIT_PAYMENT_ITEM_SUCCEEDED, data: result, next: action.next, nextParams: action.nextParams });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDoPaymentRequest() {
  yield takeEvery(EDIT_PAYMENT_ITEM_REQUESTED, doPaymentRequest);
}

function* doPaymentSuccess(action) {
  const router = AppInjector.get(Router);
  let next = action.next ? action.next : 'payment/send';
  router.navigate([next], {queryParams: {untouched: true, ...(action.nextParams ? action.nextParams : {})}});
}

function* watchDoPaymentSuccess() {
  yield takeEvery(EDIT_PAYMENT_ITEM_SUCCEEDED, doPaymentSuccess);
}

function* getDetailRequest(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.payment.getItemById(action.id).toPromise();
    yield put({ type: FETCH_PAYMENT_DETAIL_SUCCEEDED, data: result });
    let userId = result[result.object_type].getUserId();
    if (userId) {
      yield put({ type: FETCH_CUSTOMER_DETAIL_REQUESTED, data: result[result.object_type].getUserId() });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchGetDetailRequest() {
  yield takeEvery(FETCH_PAYMENT_DETAIL_REQUESTED, getDetailRequest);
}

function* listPaymentMethods(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.payment.listPaymentMethods().toPromise();
    yield put({type: GET_PAYMENT_METHODS_SUCCEEDED, data: results});
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchListPaymentMethodRequest() {
  yield takeEvery(GET_PAYMENT_METHODS_REQUESTED, listPaymentMethods);
}

function* sendToAccounting(action) {
  const api = AppInjector.get(ApiService);
  try {
    yield api.payment.sendToAccountingTool(action.data).toPromise();
    AppInjector.get(NotificationService).show('success', 'Sent to accounting tools!', 3000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSendToXeroRequest() {
  yield takeEvery(SEND_PAYMENT_TO_ACCOUNTING_REQUESTED, sendToAccounting);
}

function* cancelPayment(action) {
  const api = AppInjector.get(ApiService);
  try {
    yield api.payment.cancel(action.data.id).toPromise();
    yield put({ type: CANCEL_PAYMENT_SUCCEEDED, next: action.next, nextParams: action.nextParams });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchCancelPaymentRequest() {
  yield takeEvery(CANCEL_PAYMENT_REQUESTED, cancelPayment);
}

function* doPaymentCancelSuccess(action) {
  const router = AppInjector.get(Router);
  let next = action.next ? action.next : 'payment/send';
  router.navigate([next], {queryParams: {untouched: true, ...(action.nextParams ? action.nextParams : {})}});
}

function* watchDoPaymentCancelSuccess() {
  yield takeEvery(CANCEL_PAYMENT_SUCCEEDED, doPaymentCancelSuccess);
}

export default [watchDoPaymentRequest, watchDoPaymentSuccess, watchGetDetailRequest, watchListPaymentMethodRequest, watchSendToXeroRequest, watchCancelPaymentRequest, watchDoPaymentCancelSuccess];
